
import { devConfig } from '../app/settings-config/settings.config.dev';
import { prodConfig } from './settings-config/settings.config.prod';

let config = prodConfig; //devConfig; //    // <====change to switch between prod and dev 


export const firebaseConfig = config.firebaseConfig;
export const rootPathRef = config.rootPathRef;
export const worldpay = config.worldpay;
export const icons = config.icons;
export const cloudinarUpload = config.cloudinarUpload
export const oneSignalConfig = config.oneSignalConfig;
export const serverConfig = config.serverConfig;
export const storeInfo = config.storeInfo;
export const googleId = config.googleId;
export const facebookId = config.facebookId;
export const finixConfig = config.finixConfig;


// WEBPACK FOOTER //
// ./src/app/settings.config.ts